import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { signInPage } from './SignInPage';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
